/**
 * Proof-of-play flush triggers (P2 / P2b): playlist / Book order attribution boundaries.
 * Frame identity changes accumulate duration but do not POST (coalesced to wall-bucket /
 * attribution / visibility / teardown — not the 60s uptime tick).
 */

export function proofOfPlayAttributionKey(args: {
  playlistUrn: string | null | undefined
  orderId: string | null | undefined
}): string {
  return `${args.playlistUrn ?? ''}\t${args.orderId ?? ''}`
}

export function shouldFlushProofOfPlayOnAttributionChange(
  prevKey: string,
  nextKey: string
): boolean {
  if (prevKey === nextKey) {
    return false
  }
  // Skip idle → first attribution (nothing accumulated under the previous key).
  if (prevKey === '\t' || prevKey === '') {
    return false
  }
  return true
}
